import { createContext } from "react";

const Theme = createContext({ theme: "dark", setTheme: () => {} });

export default Theme;
